/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  BookingEventPageDto,
  SearchBookingEventsParams,
  SearchBookingEventsRequestDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * @summary searchBookingEvents
 */
export const searchBookingEvents = (
    searchBookingEventsRequestDto: BodyType<SearchBookingEventsRequestDto>,
    params?: SearchBookingEventsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingEventPageDto>(
      {url: `/fleet/events/searches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchBookingEventsRequestDto,
        params, signal
    },
      );
    }
  


export const getSearchBookingEventsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchBookingEvents>>, TError,{data: BodyType<SearchBookingEventsRequestDto>;params?: SearchBookingEventsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchBookingEvents>>, TError,{data: BodyType<SearchBookingEventsRequestDto>;params?: SearchBookingEventsParams}, TContext> => {

const mutationKey = ['searchBookingEvents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchBookingEvents>>, {data: BodyType<SearchBookingEventsRequestDto>;params?: SearchBookingEventsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  searchBookingEvents(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchBookingEventsMutationResult = NonNullable<Awaited<ReturnType<typeof searchBookingEvents>>>
    export type SearchBookingEventsMutationBody = BodyType<SearchBookingEventsRequestDto>
    export type SearchBookingEventsMutationError = ErrorType<unknown>

    /**
 * @summary searchBookingEvents
 */
export const useSearchBookingEvents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchBookingEvents>>, TError,{data: BodyType<SearchBookingEventsRequestDto>;params?: SearchBookingEventsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchBookingEvents>>,
        TError,
        {data: BodyType<SearchBookingEventsRequestDto>;params?: SearchBookingEventsParams},
        TContext
      > => {

      const mutationOptions = getSearchBookingEventsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    